module.exports = __webpack_public_path__ + "img/ic-map-plus.bda8761d.svg";